import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {
  isBuyer = false;
  isSupplier = false;

  constructor(private cookieService: CookieService) {}

  ngOnInit(): void {
    const role = (this.cookieService.get('userRole') || '').trim().toLowerCase();
    this.isBuyer = role === 'owner';
    this.isSupplier = role === 'suppliers';
  }
}

